<template>
  <div id="app-foot">
    <div class="foot-box">
      <div class="foot-top">
        <div class="foot-l">
          <ul>
            
            <li>
              <p>邮箱</p>
              <h5>{{info.email}}</h5>
            </li>
            <li>
              <p>地址</p>
              <h5>{{info.address}}</h5>
            </li>
          </ul>
        </div>
        <div class="foot-r">
          <i>
            <img src="../../assets/images/code2.png" alt />
          </i>
          <p>扫码关注我们了解更多讯息</p>
        </div>
      </div>
      <div class="foot-bottom">
        <div class="b-box">
          <div class="b-left">
            <p>顺丰公益版权所有 <a style="color:#999" href="http://beian.miit.gov.cn/" target="_blank">{{info.icp_no}}</a></p>
            <p>COPYRIGHT © 2014 SF-EXPRESS.COM INC. ALL RIGHTS RESERVE</p>
          </div>
          <div class="b-right">
            <span>技术支持：<a style="color:#999" href="http://www.puyiyun.com/" target="_blank">普益云科技</a></span>
          </div>
        </div>
      </div>
    </div>
    <el-backtop target=".el-scrollbar__wrap"></el-backtop>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: 0,
      info:{}
    };
  },
  methods: {
    
  },
  mounted() {
    this.$db.post(this.$url.website.list).then(resp => {
      if (resp && resp.data.length) {
        this.info = resp.data[0];
        console.log(this.info,"info")
      }
    });
  }
};
</script>

<style lang="scss" scoped>
#app-foot {
  width: 100%;
  height: 243px;
  background-color: #f5f5f5;
}
.foot-box {
  .foot-top {
    max-width: 1300px;
    margin: 0 auto;
    padding: 22px 0;
    position: relative;
    display: flex;
    justify-content: space-between;
    .foot-l {
      width: 980px;
      height: 48px;
      padding-top: 28px;
      > ul {
        display: flex;
        justify-content: space-between;
        > li {
          list-style: none;
          height: 100%;
          > p {
            font-size: 14px;
            color: #989898;
          }
          > h5 {
            font-size: 16px;
            font-weight: normal;
            color: #333333;
            margin-top: 10px;
          }
        }
      }
    }
    .foot-r {
      width: 87px;
      height: 103px;
      padding-left: 115px;
      position: relative;
      > i {
        width: 103px;
        height: 103px;
        position: absolute;
        left: 0;
        top: 0;
        > img {
          width: 100%;
          height: 100%;
        }
      }
      > p {
        font-size: 14px;
        line-height: 24px;
        color: #333333;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .foot-bottom {
    width: 100%;
    border-top: 1px solid #e9e9e9;
    .b-box {
      max-width: 1300px;
      margin: 0 auto;
      padding: 26px 0;
      display: flex;
      justify-content: space-between;
      .b-left {
        > p {
          font-size: 14px;
          font-weight: normal;
          // line-height: 30px;
          margin-bottom: 10px;
          color: #999999;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .b-right {
        > span {
          font-size: 14px;
          font-weight: normal;
          color: #999999;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue